function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.405524164 6.61557486C-.135174721 6.10301749-.135174721 5.27198864.405524164 4.75942179L5.02094464.384421583C5.56166353-.128140528 6.43835172-.128140528 6.97908061.384421583L11.5944571 4.75942179C12.135181 5.27197916 12.135181 6.10300801 11.5944571 6.61557486 11.0537322 7.12814171 10.177044 7.12814171 9.63631513 6.61557486L6.00001237 3.16865688 2.36371012 6.61557486C1.82302124 7.12814171.946323048 7.12814171.405524164 6.61557486zM.405524164 10.3844251C-.135174721 10.8969825-.135174721 11.7280114.405524164 12.2405782L5.02094464 16.6155784C5.56166353 17.1281405 6.43835172 17.1281405 6.97908061 16.6155784L11.5944571 12.2405782C12.135181 11.7280208 12.135181 10.896992 11.5944571 10.3844251 11.0537322 9.87185829 10.177044 9.87185829 9.63631513 10.3844251L6.00001237 13.8313431 2.36371012 10.3844251C1.82302124 9.87185829.946323048 9.87185829.405524164 10.3844251z"
});

var SvgSelect = function SvgSelect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSelect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/select.a854becc.svg";
export { ForwardRef as ReactComponent };